export const REGION_VALUES = [
  'TASHKENT_CITY',
  'TASHKENT',
  'FERGANA',
  'ANDIJAN',
  'NAMANGAN',
  'SAMARKAND',
  'BUKHARA',
  'SIRDARYA',
  'SURKHANDARYA',
  'NAVOI',
  'QASHQADARYA',
  'KHOREZM',
  'JIZZAKH',
  'KARAKALPAKSTAN',
  'XIVA',
] as const;

export type Region = (typeof REGION_VALUES)[number];
